import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { solutionStats } from '../../data/site';
import { lessonPhases } from '../../data/lessons';
import { padNumber } from '../../utils/format';
export function Solution() {
  let lessonNumber = 0;
  return <section aria-labelledby="solution-title" className="bg-deepest py-14 text-white sm:py-20 lg:py-24" data-id="element-246" data-mp="3rcx5g6mzm452">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-247" data-mp="971083ski0vh">
        <SectionHeading id="solution-title" eyebrow="The solution" lead="Meet" highlight="Badminton Class Ready" intro="A complete, ready-to-teach beginner badminton unit for PE teachers and new school or youth coaches working with children aged 9–12. Every lesson shows what to set up, what to say and what to look for — so you can walk in and teach." data-id="element-248" data-mp="49904mhrr8g7" />

        <ul className="mt-10 grid grid-cols-2 border border-white/15 sm:mt-12 lg:grid-cols-4" data-id="element-249" data-mp="nxrq36almpvy">
          {solutionStats.map((stat, index) => <li key={stat.label} className={`bg-pine/60 px-3 py-5 text-center sm:py-7 ${index % 2 === 1 ? 'border-l border-white/15' : ''} ${index > 1 ? 'border-t border-white/15 lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-250" data-mp="1vw9o3jnlxrd8" data-mpi={index}>
              <span className="block font-display text-[44px] font-bold leading-none text-gold sm:text-[64px]" data-id="element-251" data-mp="29s52bc72aeaa">
                {stat.value}
              </span>
              <span className="mt-2 block text-[12px] font-bold uppercase tracking-[0.14em] text-white/80 sm:text-[13px]" data-id="element-252" data-mp="2ituuwlcojj9n">
                {stat.label}
              </span>
            </li>)}
        </ul>

        <h3 className="mt-12 text-center font-display text-[28px] font-bold uppercase leading-none sm:mt-16 sm:text-[36px]" data-id="element-253" data-mp="2sk7mgxiwwcpa">
          A clear 12-lesson progression
        </h3>
        <ol className="relative mt-8 grid gap-7 sm:mt-10 sm:gap-8 lg:grid-cols-4 lg:gap-6" data-id="element-254" data-mp="32jyij3n4ezrh">
          <span aria-hidden="true" className="absolute bottom-2 left-[19px] top-2 w-0.5 bg-gold/35 lg:bottom-auto lg:left-0 lg:right-0 lg:top-[19px] lg:h-0.5 lg:w-auto" data-id="element-255" data-mp="2ctyi2rtpnr9m" />
          {lessonPhases.map((phase, phaseIndex) => <li key={phase.range} className="relative pl-16 lg:pl-0 lg:pt-16" data-id="element-256" data-mp="2mme0fq8x6hv1" data-mpi={phaseIndex}>
              <span aria-hidden="true" className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border-2 border-gold bg-deepest font-display text-xl font-bold text-gold" data-id="element-257" data-mp="2hsje0f1xjos9">
                {phaseIndex + 1}
              </span>
              <p className="text-[13px] font-bold uppercase tracking-[0.14em] text-gold" data-id="element-258" data-mp="35hcfss58gqus">{phase.range}</p>
              <p className="mt-1 font-display text-[26px] font-bold uppercase leading-tight" data-id="element-259" data-mp="30iho10pafryj">{phase.title}</p>
              <ul className="mt-3 space-y-1.5" data-id="element-260" data-mp="166b0r3j4dkpv">
                {phase.lessons.map(lesson => {
              lessonNumber += 1;
              return <li key={lesson} className="flex gap-2.5 text-base text-white/80" data-id="element-261" data-mp="3hu6cnjhpi14s">
                      <span className="w-6 shrink-0 font-bold tabular-nums text-white" data-id="element-262" data-mp="3mrg414onomv9">{padNumber(lessonNumber)}</span>
                      {lesson}
                    </li>;
            })}
              </ul>
            </li>)}
        </ol>

        <div className="mt-10 text-center sm:mt-14" data-id="element-263" data-mp="2z2natfzf4t4c">
          <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-264" data-mp="2z59kbl5vdip7">
            See what’s included
          </CtaButton>
        </div>
      </div>
    </section>;
}